import { RESOURCE_NAME } from '@esentai/core/features/mallStats/consts';
import { canCreate, canRead, canUpdate } from '@esentai/core/policy-dsl';

import { authorizeIf } from '@/features/currentUser/rbac';

export const canReadMallStats = authorizeIf(canRead(RESOURCE_NAME));
export const canReadMallStat = authorizeIf(canRead(RESOURCE_NAME));
export const canCreateMallStat = authorizeIf(canCreate(RESOURCE_NAME));
export const canUpdateMallStat = authorizeIf(canUpdate(RESOURCE_NAME));
